import "../src/styles/globals.scss";
import "locomotive-scroll/dist/locomotive-scroll.css";
import { AnimatePresence } from "framer-motion";
import { useRouter } from "next/router";
import type { AppProps } from "next/app";
import Head from "next/head";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/dist/ScrollTrigger";
// import { Flip } from "gsap/dist/Flip";
// import { GSDevTools } from "@utils/gsap/GSDevTools";
// import { DrawSVGPlugin } from "@utils/gsap/DrawSVGPlugin";
import { SplitText } from "@utils/gsap/SplitText";
import { useEffect } from "react";
import Clarity from "@microsoft/clarity";

if (typeof window !== "undefined") {
  gsap.registerPlugin(
    // Flip,
    ScrollTrigger,
    // GSDevTools,
    // DrawSVGPlugin,
    SplitText
  );
}

function MyApp({ Component, pageProps }: AppProps) {
  const router = useRouter();
  const siteUrl = process.env.NEXT_PUBLIC_SITE_URL || "https://www.inawo.com";
  const canonicalPath = router.asPath.split("?")[0].split("#")[0];
  const canonicalUrl =
    canonicalPath === "/" ? siteUrl : `${siteUrl}${canonicalPath}`;

  useEffect(() => {
    if (process.env.NEXT_PUBLIC_INAWO_ENV === "live") {
      const clarityProjectId = process.env.NEXT_PUBLIC_CLARITY_PROJECT_ID;

      if (clarityProjectId) {
        Clarity.init(clarityProjectId);
      } else {
        console.warn("CPID not found");
      }
    }
  }, []);

  return (
    <>
      <Head>
        <title>Inawo | Africa&apos;s Leading Wedding Management Software</title>
        <meta
          name="description"
          content="Plan your wedding in one place with Inawo. Create your wedding website, manage guests and RSVP, digital invites, budgets, vendors, and venues."
        />
        <meta name="robots" content="index, follow" />
        <link rel="canonical" href={canonicalUrl} />
        <link rel="alternate" hrefLang="en" href={canonicalUrl} />
        <link rel="alternate" hrefLang="x-default" href={canonicalUrl} />
      </Head>

      <AnimatePresence exitBeforeEnter>
        <Component {...pageProps} key={router.asPath} />
      </AnimatePresence>
    </>
  );
}

export default MyApp;
